/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_PostsInputs */

const en_admin_nav_posts = /** @type {(inputs: Admin_Nav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posts`)
};

const zh_admin_nav_posts = /** @type {(inputs: Admin_Nav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章`)
};

/**
* | output |
* | --- |
* | "Posts" |
*
* @param {Admin_Nav_PostsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_posts = /** @type {((inputs?: Admin_Nav_PostsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_PostsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_posts(inputs)
	return zh_admin_nav_posts(inputs)
});
export { admin_nav_posts as "admin.nav.posts" }